import React from 'react';

/**
 * TutorialSpotlight Component
 *
 * Creates a spotlight effect around a target element during the tutorial.
 * Uses SVG mask to create a "cutout" effect in the overlay.
 *
 * @param {Object} rect - The bounding rect of the target element
 * @param {boolean} allowClick - If true, allows clicks to pass through to the target
 */
function TutorialSpotlight({ rect, allowClick = false }) {
  if (!rect) return null;

  const padding = 8; // Extra padding around the highlighted element

  return (
    <>
      {/* SVG mask to create the spotlight cutout */}
      <svg
        className="tutorial-spotlight-svg"
        width="100%"
        height="100%"
        aria-hidden="true"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          pointerEvents: 'none',
          zIndex: 10200,
        }}
      >
        <defs>
          <mask id="tutorial-spotlight-mask">
            {/* White = visible, black = hidden */}
            <rect x="0" y="0" width="100%" height="100%" fill="white" />
            <rect
              x={rect.left - padding}
              y={rect.top - padding}
              width={rect.width + padding * 2}
              height={rect.height + padding * 2}
              rx="8"
              ry="8"
              fill="black"
            />
          </mask>
        </defs>

        {/* Semi-transparent overlay with cutout */}
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill="rgba(0, 0, 0, 0.75)"
          mask="url(#tutorial-spotlight-mask)"
        />
      </svg>

      {/* Highlight border around the target */}
      <div
        className="tutorial-spotlight-highlight"
        style={{
          position: 'fixed',
          top: rect.top - padding,
          left: rect.left - padding,
          width: rect.width + padding * 2,
          height: rect.height + padding * 2,
          borderRadius: '8px',
          border: '2px solid var(--primary, #2d5a47)',
          boxShadow: '0 0 0 4px rgba(45, 90, 71, 0.3), 0 0 20px rgba(45, 90, 71, 0.4)',
          pointerEvents: allowClick ? 'none' : 'auto',
          zIndex: 10200,
          animation: 'tutorial-pulse 2s ease-in-out infinite',
        }}
      />
    </>
  );
}

export default TutorialSpotlight;
